import styled from "@emotion/styled"
import Container from "components/Container"

const ArticleContainer = styled(Container)`
  display: flex;
  position: relative;
  gap: 30px;

  ${({ theme }) => theme.breakpoints.down("xl")} {
    flex-direction: column;
  }

  ${({ theme }) => theme.breakpoints.up("xl")} {
    flex-direction: row-reverse;
    justify-content: space-between;
  }
`

export default ArticleContainer
